import React, { useEffect, useState } from 'react';

//redux
import { useDispatch, useSelector } from 'react-redux'
import WorkspacesAction from '../../../redux/actions/workspaces/WorkspacesAction';
import { IRootState } from 'redux/reducers';

//interfaces
import { Workspace } from '../../../interfaces/workspaces';

//components
import YourWorkspacesModal from '../../modals/YourWorkspacesModal';
import { WorkspaceItem } from './WorkspaceItem';
import ModalWrapper from '../../modals/ModalWrapper';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import ToolTipWrapper from '../Tooltip/ToolTipWrapper'

import '../../../css/yourWorkspaces.scss';



const YourWorkspaces = (props:any) => {

    const dispatch = useDispatch()
    const [openModal, SetModal] = useState(false)  
    const {allWorkspaces, top5Workspaces, workspacesRemaining, totalWorkspaces }= useSelector((state: IRootState)  => state.workspaces)

    useEffect(() => {

        dispatch(WorkspacesAction.requestWorkspaces())
        
    }, [])

    const Label = () => {

        if (top5Workspaces.length === 0){
           return <p>Sorry, you dont have any workspaces setup yet - please contact your admin</p>   
        }

        return null
    }

    return (

        <section className={`${top5Workspaces ? 'fade-in-shown' : 'fade-in-hidden'} thrive-panel thrive-small-panel-right sml-workspace-header`}>

            <h1>Your Workspaces</h1>

            <ToolTipWrapper id="workspace-tooltip" className="tracks-side-tooltip">
                <ReactTooltip id="workspace-tooltip" place="top" className='thrive-tooltip' delayHide={1000} >
                    <span>Manage your content, users and settings</span>
                </ReactTooltip>
            </ToolTipWrapper>
           
            <Label />
            
            <section className="sml-workspace-list">
                <ul>
                    {top5Workspaces.filter((i,index) => (index < 5)).map((x:Workspace) => {
                        return(
                            <WorkspaceItem item={x} key={x.guid} count={true} showmodel={false} titleLength={19} />
                        )  
                    })}
                </ul>
          
                {(workspacesRemaining > 0 || allWorkspaces.length > 5)  &&
                    <a href="#" onClick={() => SetModal(true)}>See all {totalWorkspaces} workspaces</a>
                }
            </section>
        
            <ModalWrapper isOpen={openModal} onRequestClose={() => SetModal(false)}>
                <YourWorkspacesModal onClose={() => SetModal(false)} showWelcome={false}  />
            </ModalWrapper> 

        </section>

    );
}

export default YourWorkspaces;